function slugify(str) {
  return encodeURIComponent(
    str.toLowerCase().replace(/æ/g, "ae").replace(/ø/g, "oe").replace(/å/g, "aa").replace(/\s|_/g, "-").replace(/[^a-z0-9-]/g, "").replace(/--/g, "-").replace(/--/g, "-").replace(/--/g, "-")
  );
}

export { slugify };
//# sourceMappingURL=string.slugify.js.map
